import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatDialogModule } from "@angular/material/dialog";
import { LorenAssetSelectionDialogComponent } from "./components/loren-asset-selection-dialog/loren-asset-selection-dialog.component";
import { LorenEntityFormModule } from "../loren-entity-form/loren-entity-form.module";

@NgModule({
  declarations: [LorenAssetSelectionDialogComponent],
  exports: [LorenAssetSelectionDialogComponent],
  imports: [MatDialogModule, LorenEntityFormModule, CommonModule],
})
export class LorenAssetSelectionDialogModule {}
